<template>
    <v-card
      elevation="1"
      class="pa-6 mt-6"
    >
      <div>
        <h4 class="mb-4 d-flex justify-space-between align-center">
          Lists ({{ selectedLists.length }})
          <v-btn
            v-if="selectedLists.length && !toggleDNMSwitch && checkProduct"
            icon
            text
            @click="toggleDrawer()"
            v-track="'show-hide-list-drawer'"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="selectedLists.length && toggleDNMSwitch"
            text
            @click="getSelectedLists()"
            v-track="'get-selected-list'"
            color = "#03B6FC"
          >
            <v-icon v-if="listLoader">mdi-spin mdi-refresh</v-icon>
            <v-icon v-if="!listLoader"> refresh </v-icon>
            <span class="caption" style="text-transform: capitalize;">  Refresh</span>
          </v-btn>
        </h4>
        <v-skeleton-loader
          v-if="listLoader"
          type="list-item-three-line, action"
        />
        <div v-else>
        <div v-if="selectedLists.length">
          <v-chip
            v-for="list in selectedLists.slice(
              0,
              showAllTags? selectedLists.length : 3
            )"
            :key="list.id"
            class="my-1 mr-4 "
            color="#cce1ef"
          >
            {{ list.name }}
          </v-chip>
          <v-btn
            v-if="selectedLists.length > 3"
            text
            @click="showAllTags = !showAllTags"
            v-track="'show-hide-all-tags'"
          >
            VIEW {{ showAllTags ? "LESS" : "ALL" }}
          </v-btn>
        </div>
        <div
          v-if="!selectedLists.length"
          style="min-height: 81.9px;"
          class="d-flex flex-column "
        >
          <v-label> No Lists to show.</v-label>
          <v-label>Add the customer to lists to send emails.</v-label>
          <div class="mt-6">
            <v-tooltip
              bottom
              right
              :disabled="!toggleDNMSwitch"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="checkProduct"
                  outlined
                  :style="toggleDNMSwitch?'cursor:not-allowed':'cursor:pointer'"
                  :ripple="!toggleDNMSwitch"
                  @click.stop="!toggleDNMSwitch?toggleDrawer():''"
                  v-on="on"
                  v-track="'show-hide-DNM-switch'"
                >
                  ADD TO LISTS
                </v-btn>
              </template>
              <span>To add the customer to lists<br> turn off the DNM switch first</span>
            </v-tooltip>
          </div>
        </div>
        </div>
        <v-divider v-if="checkProduct" class="mt-7" />
        <div v-if="checkProduct" class="d-flex justify-space-between align-center mb-n6">
          <label> Add to Do Not Mail List</label>
          <v-switch
            v-track="'add-remove-dnm-switch'"
            v-model="toggleDNMSwitch"
            color="#03B6FC"
            @click.stop.prevent="showPrompt = true"
          />
          </div>
          <div v-if="showReason">
            <v-row>
              <v-col cols="1" class="pb-0">
                <v-icon>mdi-menu-right</v-icon>
              </v-col>
              <v-col class="pb-0">
                <span v-if="dnmReason === null" class="body-2 dnm-text">
                  Contact added to DNM <b>- Reason : Not Available</b>
                </span>
                <span class="body-2 dnm-text" v-else>
                  Contact added to DNM via <b>{{ dnmReason }}</b>
                </span>
              </v-col>
            </v-row>
            <div class="ml-10" v-if="showDescription">
              <v-row no-gutters>
                <v-col cols="1">
                  <v-icon>mdi-subdirectory-arrow-right</v-icon>
                </v-col>
                <v-col class="mt-1">
                  <span class="body-2 dnm-text">
                    Through <b>'{{ dnmReasonDescription }}'</b>
                  </span>
                </v-col>
              </v-row>
            </div>
          </div>  
          <v-dialog
            v-model="showPrompt"
            max-width="500"
          >
            <v-card class="standard-modal">
              <v-card-title class="secondary--font">
                <h4> {{ toggleDNMSwitch?'Remove from':'Add to' }} Do Not Mail List? </h4>
              </v-card-title>

              <v-card-subtitle v-if="toggleDNMSwitch" class="subtitle-1 only-top-padding">
                The customer will be subscribed to the lists they are added to and will receive all marketing emails once removed from the Do Not Mail List.
              </v-card-subtitle>
              <v-card-subtitle v-else class="subtitle-1 only-top-padding">
                The customer will automatically be unsubscribed from all the lists and No marketing emails will be sent once added to the Do Not Mail List.
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer />

                <v-btn
                  v-track="'cancel-dnm-btn'"
                  text
                  class="body-2 font-weight-bold"
                  @click="showPrompt = false"
                >
                  CANCEL
                </v-btn>

                <v-btn
                  v-track="'add-remove-dnm-btn'"
                  text
                  :loading="listLoader"
                  class="body-2 font-weight-bold"
                  @click.stop="addToDNM"
                >
                  {{ toggleDNMSwitch ? "REMOVE" : "ADD" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        
      </div>
    </v-card>
</template>
<script>
  import { $marketingContacts } from "@core/services"
  export default {
    props: {
      contactId: [Number, String],
      contact: {
        type: String,
      },
    },
    data () {
      return {
        selectedLists:[],
        listLoader: false,
        showAllTags:false,
        drawer: false,
        toggleDNMSwitch: false,
        showReason: false,
        showDescription: false,
        dnmReason: '',
        dnmReasonDescription: '',
        showPrompt: false,
      }
    },
    watch: {
      '$store.state.ui.drawer.right.response': function () {
        if (this.$store.getters['ui/drawer'].right.response.contactList) {
          this.selectedLists = this.$store.getters['ui/drawer'].right.response.contactList
        }
      },
      contact(value){
        if(value)
          this.getSelectedLists()
      }
    },
    computed:{
      checkProduct(){
       return process.env.VUE_APP_PRODUCT != 'Service'
      }
    },
    mounted () {
      // Fetch all selected Tags
      this.getDNMStatus()
    },
    methods: {
      getSelectedLists () {
        this.listLoader = true
        const payload = {
          params: {
            'contact[email]': this.contact
          }
        }
        $marketingContacts.getSubscribedLists(this.contactId,payload).then(response => {
          this.selectedLists = response.data.data.subscribed_lists
          this.listLoader = false
        })
      },
      toggleDrawer () {
        this.$store.state.ui.drawer.right.component = 'lists-drawer'
        // this.contactList = JSON.parse(JSON.stringify(this.contactList))
        this.$store.state.ui.drawer.right.show = true
        this.drawer = !this.drawer
      }, 
      getDNMStatus () {
        this.showReason = false
        this.showDescription = false
        $marketingContacts.dnmStatus(this.contactId).then(response => {
          this.toggleDNMSwitch = response.data.response
          this.dnmReason = response.data.reason_type
          this.dnmReasonDescription = response.data.reason_description
          if(this.toggleDNMSwitch) {
            this.showReason = true
          }
          if(this.dnmReasonDescription) {
            this.showDescription = true
          }
        })
      },
      addToDNM () {
        this.listLoader = true
        $marketingContacts.updateDNMStatus(this.toggleDNMSwitch, {
          contact_id: this.contactId,
        },
        ).then((response) => {
          this.listLoader = false
          this.getSelectedLists()
          this.getDNMStatus()
          this.showPrompt = false
          this.toggleDNMSwitch = !this.toggleDNMSwitch
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.dnm-text {
  color: rgba(0, 0, 0, 0.6);
}
</style>